import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import posthog from 'posthog-js'

import { BrowserRouter } from "react-router-dom";

// Initialize PostHog
posthog.init('phc_8h5S7osAQugx7m4CtIOvx2VvKL8gTeluzwguFUHuqCJ', {
  api_host: 'https://app.posthog.com',
  loaded: (posthog) => {
    if (process.env.NODE_ENV === 'development') posthog.debug()
  },
  capture_pageview: true,
  capture_pageleave: true,
  autocapture: true
})

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
